import { useMutation } from '../../index';
import permissions from '../../Apollo/permissions';
import { validate } from 'parameter-validator';
import { useUserContext } from '@ion/user';

import { buildVariables, mutation } from './remove-integration-mutation-builder';

export const combinedMutation = mutation;

export default function useRemoveIntegration(options = {}) {
  const { user, currentOrg } = useUserContext();
  const userData = { email: user?.email, org: currentOrg?.display_name };
  const [executeMutation, response] = useMutation(combinedMutation, {
    successMsg: 'Integration removed.',
    context: { permission: permissions.deleteIntegration },
    ...options,
    update: buildUpdateCache(userData),
  });

  const removeIntegrationMutation = args => {
    const { integrationId } = validate(args, ['integrationId']);

    return executeMutation({
      variables: {
        ...buildVariables({ integrationId }),
      },
    });
  };

  return [removeIntegrationMutation, response];
}

function buildUpdateCache(userData) {
  return (cache, { data }) => {
    // Remove from cache on "soft delete"
    const deletedIntegration = data.update_integrations_by_pk;

    track({ deletedIntegration, userData });

    // remove it from cache
    cache.evict({ id: cache.identify(deletedIntegration) });
    cache.gc();
  };
}

function track({ deletedIntegration, userData }) {
  __mrTracking?.track('integration_deleted', {
    id: deletedIntegration.id,
    name: deletedIntegration.name,
    starterkitId: deletedIntegration.starterkitId,
    starterkitVersion: deletedIntegration.starterkitVersion,
    userEmail: userData.email,
    orgName: userData.org,
  });
}
